export const FALLBACK_TIMEZONE = "UTC";

/**
 * Returns the local IANA timezone resolved from the current runtime.
 */
export function getLocalTimezone(): string {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone || FALLBACK_TIMEZONE;
}

/**
 * Resolves the effective timezone used by the app state.
 */
export function getEffectiveTimezone(
  practiceTimezone: string | undefined,
  userTimezone: string,
): string {
  return practiceTimezone || userTimezone;
}
